<!--
  ~ Copyright The Linux Foundation and each contributor to LFX.
  ~ SPDX-License-Identifier: MIT
  -->

<div class="chart-card-container">
  <div [id]="chartName" class="chart"></div>
</div>
